import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const footerLinks = [
  {
    title: "内容分类",
    links: [
      { label: "美女写真", path: "/category/meinv-xiezhen" },
      { label: "时尚穿搭", path: "/category/shishang-chuanda" },
      { label: "美妆教程", path: "/category/meizhuang-jiaocheng" },
      { label: "生活方式", path: "/category/shenghuo-fangshi" },
      { label: "博主推荐", path: "/category/bozhu-tuijian" },
      { label: "写真图集", path: "/category/xiezhen-tuji" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", path: "/about" },
      { label: "联系方式", path: "/about#contact" },
      { label: "常见问题", path: "/about#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-xl font-bold mb-4 block"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <span className="text-primary-400">美</span>
              <span className="text-background-50">女网站精选</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mt-3">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a
                href={siteInfo.social.weibo}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href={siteInfo.social.xiaohongshu}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="小红书"
              >
                <i className="ri-red-packet-line"></i>
              </a>
              <span className="text-foreground-400 text-xs">
                微信：{siteInfo.social.wechat}
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="text-sm text-foreground-400">
                <i className="ri-mail-line mr-2"></i>
                {siteInfo.email}
              </li>
              <li className="text-sm text-foreground-400">
                <i className="ri-phone-line mr-2"></i>
                {siteInfo.phone}
              </li>
              <li className="text-sm text-foreground-400">
                <i className="ri-map-pin-line mr-2"></i>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 |
            本站内容仅供学习交流，请勿用于商业用途
          </p>
          <p className="text-xs text-foreground-500">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-foreground-400 transition-colors"
            >
              沪ICP备2024000000号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}